<template>
	<div class="form-group mt-2">
		<label class="form-label" :for="'uniq_id_' + f_uniq">
			{{f_title}}
		</label>

		<div class="input-group flex-nowrap">
			<div class="input-group-prepend">
				<span class="input-group-text">
					<i class="fal  fs-xl" :class="f_icon"></i>
				</span>
			</div>



			<b-form-input
                v-if="!is_phone"
                class="form-control"
                :id="'uniq_id_' + f_uniq"
                @change="updateValue"
                v-model="drw_field"
                :disabled="is_disabled" >

            </b-form-input>

            <the-mask
                v-else
                :mask="['+## (###) ###-##-##','+## (###) ###-##-##']"
                ref="phone_inp"
                class="form-control  bg-transparent"
                id="my-phone"
                type="text"
                @change="updateValue"
                key="order_phone"
                v-model="drw_field"
                :masked="false"/>

		</div>
	</div>
</template>

<script>
export default {
	name: "info_field",
	props : {
		is_disabled : {
			type : Boolean,
			default: true
		},

		f_icon : {
			type:String,
			default : "fa-address-book",
		},
		f_type : {
			type : String,
			default : ""
		},

		f_title : {
			type : String,
			default : ""
		},

		f_val : {
			type : [String,Number],
			default : ""
		},

		f_uniq : {
			type : String,
			default : Math.floor(Date.now() / 1000).toString()
		}
	},
	data() {
		return  {
			cur_val : ""
		}
	},

    created () {
	    this.cur_val = this.f_val;
    },

	methods : {

        updateValue() {
            this.$emit('change',this.cur_val);
        },

		change_val() {
            this.$emit('input', this.cur_val);
            this.$emit("update_categ", this.f_type,this.cur_val);
		}
	},
	computed  : {

        is_phone() {
            return this.f_type == 'order_phone';
        },


		drw_field: {
			get: function () {
				return this.f_val;
			},

			set: function (newValue) {
				this.cur_val = newValue;
				this.change_val();
			}
		}
	}
}
</script>

<style scoped>

</style>
